/** Short brand used in `<title>` tags after `|`. Keep homepage `site.title` long-form. */
export const TITLE_SUFFIX = 'Transcend';

export function formatPageTitle(
  pageTitle: string | undefined,
  siteTitle: string,
  isHomepage?: boolean,
): string {
  if (isHomepage || !pageTitle) {
    return siteTitle;
  }
  return `${pageTitle} | ${TITLE_SUFFIX}`;
}
